var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNiveau4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.3 35.8",
    style: {
      enableBackground: "new 0 0 25.3 35.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M19,7.8c-1.6-2.6-3.2-4.9-4.2-6.3c-0.4-0.6-1-1.4-2.2-1.4c-1.1,0-1.7,0.6-2.2,1.4c-1,1.4-2.6,3.7-4.2,6.3 c-2.3,3.7-6.2,10.7-6.1,15.3c0,4.3,1.5,7.7,4.5,10c2.1,1.6,5.1,2.6,8,2.6h0.1c2.9,0,5.8-1,8-2.6c3-2.3,4.5-5.7,4.5-10v0 C25.2,18.4,21.3,11.5,19,7.8z M8.4,9.1C10,6.6,11.5,4.4,12.5,3c0.1-0.1,0.1-0.1,0.1-0.2c0,0.1,0.1,0.1,0.1,0.2 c1,1.4,2.5,3.6,4.1,6.1c2.2,3.6,3.9,6.9,4.8,9.6H3.6C4.5,16,6.2,12.7,8.4,9.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiveau4);
export default __webpack_public_path__ + "static/media/Niveau4.28f6002d.svg";
export { ForwardRef as ReactComponent };